var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollectedAmount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47.5692,
    height: 48,
    rx: 23.7846,
    fill: "#A8FFB1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.934 22.3602C36.0292 22.3602 36.1063 22.2831 36.1063 22.1879C36.1063 22.0928 36.0292 22.0156 35.934 22.0156C35.8389 22.0156 35.7617 22.0928 35.7617 22.1879C35.7617 22.2831 35.8389 22.3602 35.934 22.3602Z",
    fill: "#231F20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5629 26.7587C33.6581 26.7587 33.7352 26.6815 33.7352 26.5864C33.7352 26.4912 33.6581 26.4141 33.5629 26.4141C33.4678 26.4141 33.3906 26.4912 33.3906 26.5864C33.3906 26.6815 33.4678 26.7587 33.5629 26.7587Z",
    fill: "#231F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7985 17.2376C13.1554 17.2376 13.4447 16.9483 13.4447 16.5915C13.4447 16.2346 13.1554 15.9453 12.7985 15.9453C12.4416 15.9453 12.1523 16.2346 12.1523 16.5915C12.1523 16.9483 12.4416 17.2376 12.7985 17.2376Z",
    stroke: "#FBD108",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.168 12.0678H30.2018M29.6849 12.5847V11.5078",
    stroke: "#F16723",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2232 12.2433C14.3422 12.2433 14.4386 12.1468 14.4386 12.0279C14.4386 11.9089 14.3422 11.8125 14.2232 11.8125C14.1042 11.8125 14.0078 11.9089 14.0078 12.0279C14.0078 12.1468 14.1042 12.2433 14.2232 12.2433Z",
    fill: "#231F20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4844 19.0872H33.5613M33.0013 19.6042V18.5703",
    stroke: "#4D9AD4",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0495 33.1292L12.1972 35.2831C11.8095 35.3262 11.4648 35.0246 11.4648 34.6369V21.8431C11.4648 21.4985 11.7233 21.24 12.0248 21.1969L28.0495 19C29.5571 19 30.7633 20.3354 30.7633 21.9292V30.1569C30.7633 31.7938 29.5571 33.1292 28.0495 33.1292Z",
    fill: "#EF5224"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4648 21.8431C11.4648 21.4985 11.7233 21.24 12.0248 21.1969L28.0495 19C29.5572 19 30.7633 20.3354 30.7633 21.9292V30.1569C30.7633 31.7938 29.5572 33.0862 28.0495 33.0862L12.1972 35.24C11.8095 35.2831 11.4648 34.9815 11.4648 34.5938",
    stroke: "#231F20",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2266 12.4844L30.3655 17.2298L23.7839 27.1311L16.6449 22.3857L23.2266 12.4844Z",
    fill: "#FAFDFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8283 27.148L17.5391 23.228L24.0868 13.3203L30.2898 17.4126L23.8283 27.148Z",
    fill: "#80C244"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8282 27.1482L22.2344 25.9421L28.6528 16.3359L30.2898 17.4129L23.8282 27.1482Z",
    fill: "#5BB947"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5989 18.4446L23.8265 27.1462L16.6758 22.3646L23.2235 12.5L30.3742 17.2385L30.1589 17.5831",
    stroke: "#231F20",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9062 12.7109L25.2242 14.7838L22.3493 26.3202L14.0314 24.2474L16.9062 12.7109Z",
    fill: "#FAFDFF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3619 26.326L15.125 24.7321L18.0112 13.1875L25.205 14.9967L22.3619 26.326Z",
    fill: "#80C244"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M22.364 26.3265L20.5117 25.7234L23.2686 14.5234L25.2071 14.9973L22.364 26.3265Z",
    fill: "#5BB947"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8723 20.2063L22.3646 26.3232L14.0508 24.2556L16.0323 16.3294M16.3339 15.1232L16.8939 12.7109L25.2508 14.7786L24.1308 19.2156",
    stroke: "#231F20",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4278 35.4574H13.0586C12.197 35.4574 11.5078 34.7681 11.5078 33.9066V22.8789C11.5078 22.0174 12.197 21.3281 13.0586 21.3281H29.4709C31.1509 21.3281 32.4863 22.6635 32.4863 24.3435V32.485C32.4432 34.122 31.1078 35.4574 29.4278 35.4574Z",
    fill: "#EF5224"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7633 35.4612H11.8095C11.5941 35.4612 11.4648 35.2888 11.4648 35.1165V21.7196C11.4648 21.5042 11.6372 21.375 11.8095 21.375H30.7633V35.4612Z",
    fill: "#F16723"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8002 35.285H11.9818C11.7233 35.285 11.4648 35.0697 11.4648 34.7681V21.845C11.4648 21.5866 11.6802 21.3281 11.9818 21.3281H12.8002V35.285Z",
    fill: "#FAFDFF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4648 26.6266V21.9743C11.4648 21.6297 11.7664 21.3281 12.111 21.3281H29.471C31.1079 21.3281 32.4002 22.6635 32.4002 24.2574V32.485C32.4002 34.122 31.0648 35.4143 29.471 35.4143H20.6833M11.4648 30.202V27.6174M19.5202 35.4574H12.1541C11.8095 35.4574 11.5079 35.1558 11.5079 34.8112V31.2358",
    stroke: "#231F20",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4695 22.6641C14.4356 22.6641 13.6172 23.4825 13.6172 24.5164M13.6172 25.4641V25.8948M13.6172 31.5379V33.9933",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6353 33.1967C27.9247 32.1056 28.6711 30.8678 28.3023 30.4319C27.9335 29.996 26.5892 30.5272 25.2997 31.6182C24.0102 32.7093 23.2638 33.9471 23.6326 34.383C24.0014 34.8189 25.3458 34.2878 26.6353 33.1967Z",
    fill: "#FBD108"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6562 34.3809C24.0439 34.8117 25.3793 34.2948 26.6716 33.2179C27.9639 32.1409 28.6962 30.8917 28.3086 30.4609L29.4286 31.7963C29.8162 32.2271 29.0839 33.4763 27.7916 34.5532C26.4993 35.6302 25.1639 36.1471 24.7762 35.7163L23.6562 34.3809Z",
    fill: "#FBD108"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2831 35.5459L26.1969 35.589C25.7231 35.9767 24.9908 35.9336 24.6031 35.4597L24 34.7274V34.6844L25.2923 34.3828L26.2831 35.5459Z",
    fill: "#FAFDFF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8227 33.5656L29.1673 33.0918C29.6412 32.7041 29.7273 31.9718 29.2965 31.4979L28.6935 30.7656H28.6504L27.875 32.4025L28.8227 33.5656Z",
    fill: "#F9AE19"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6992 34.4278C24.0869 34.8586 25.4223 34.3417 26.7146 33.2647C28.0069 32.1878 28.7392 30.9386 28.3515 30.5078L29.4715 31.8432C29.8592 32.274 29.1269 33.5232 27.8346 34.6001C26.5423 35.677 25.2069 36.194 24.8192 35.7632L23.6992 34.4278Z",
    stroke: "#231F20",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7017 33.2748C27.9912 32.1838 28.7375 30.9459 28.3687 30.51C27.9999 30.0742 26.6556 30.6053 25.3661 31.6963C24.0766 32.7874 23.3302 34.0252 23.699 34.4611C24.0678 34.897 25.4122 34.3659 26.7017 33.2748Z",
    stroke: "#231F20",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M31.41 30.3333C33.0992 30.3333 34.4685 29.8704 34.4685 29.2995C34.4685 28.7285 33.0992 28.2656 31.41 28.2656C29.7209 28.2656 28.3516 28.7285 28.3516 29.2995C28.3516 29.8704 29.7209 30.3333 31.41 30.3333Z",
    fill: "#FBD108"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3945 29.2969C28.3945 29.8569 29.773 30.3307 31.453 30.3307C33.133 30.3307 34.5115 29.8569 34.5115 29.2969V31.063C34.5115 31.623 33.133 32.0969 31.453 32.0969C29.773 32.0969 28.3945 31.623 28.3945 31.063V29.2969Z",
    fill: "#FBD108"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6438 31.8804H29.5576C28.9115 31.8804 28.3945 31.3635 28.3945 30.7173V29.7696C28.3945 29.7266 28.3945 29.7266 28.4376 29.7266L29.6438 30.3296V31.8804Z",
    fill: "#FAFDFF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M32.875 32.0096L33.435 31.8804C34.0812 31.8804 34.5981 31.3635 34.5981 30.7173V29.7696C34.5981 29.7266 34.5981 29.7266 34.555 29.7266L32.875 30.4589V32.0096Z",
    fill: "#F9AE19"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3945 29.3438C28.3945 29.9037 29.773 30.3776 31.453 30.3776C33.133 30.3776 34.5115 29.9037 34.5115 29.3438V31.1099C34.5115 31.6699 33.133 32.1438 31.453 32.1438C29.773 32.1438 28.3945 31.6699 28.3945 31.1099V29.3438Z",
    stroke: "#231F20",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3945 31.1484C28.3945 31.7084 29.773 32.1823 31.453 32.1823C33.133 32.1823 34.5115 31.7084 34.5115 31.1484V32.9146C34.5115 33.4746 33.133 33.9484 31.453 33.9484C29.773 33.9484 28.3945 33.4746 28.3945 32.9146V31.1484Z",
    fill: "#FBD108"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6438 33.732H29.5576C28.9115 33.732 28.3945 33.215 28.3945 32.5689V31.6212C28.3945 31.5781 28.3945 31.5781 28.4376 31.5781L29.6438 32.1812V33.732Z",
    fill: "#FAFDFF"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M32.875 33.9081L33.435 33.7788C34.0812 33.7788 34.5981 33.2619 34.5981 32.6158V31.6681C34.5981 31.625 34.5981 31.625 34.555 31.625L32.875 32.3573V33.9081Z",
    fill: "#F9AE19"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3945 31.2344C28.3945 31.7944 29.773 32.2682 31.453 32.2682C33.133 32.2682 34.5115 31.7944 34.5115 31.2344V33.0005C34.5115 33.5605 33.133 34.0344 31.453 34.0344C29.773 34.0344 28.3945 33.5605 28.3945 33.0005V31.2344Z",
    stroke: "#231F20",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3945 33.0469C28.3945 33.6069 29.773 34.0807 31.453 34.0807C33.133 34.0807 34.5115 33.6069 34.5115 33.0469V34.813C34.5115 35.373 33.133 35.8469 31.453 35.8469C29.773 35.8469 28.3945 35.373 28.3945 34.813V33.0469Z",
    fill: "#FBD108"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6438 35.6304H29.5576C28.9115 35.6304 28.3945 35.1135 28.3945 34.4673V33.5196C28.3945 33.4766 28.3945 33.4766 28.4376 33.4766L29.6438 34.0796V35.6304Z",
    fill: "#FAFDFF"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M32.875 35.8065L33.435 35.6773C34.0812 35.6773 34.5981 35.1604 34.5981 34.5142V33.5665C34.5981 33.5234 34.5981 33.5234 34.555 33.5234L32.875 34.2557V35.8065Z",
    fill: "#F9AE19"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3945 33.1328C28.3945 33.6928 29.773 34.1667 31.453 34.1667C33.133 34.1667 34.5115 33.6928 34.5115 33.1328V34.899C34.5115 35.459 33.133 35.9328 31.453 35.9328C29.773 35.9328 28.3945 35.459 28.3945 34.899V33.1328Z",
    stroke: "#231F20",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M31.41 30.3724C33.0992 30.3724 34.4685 29.9095 34.4685 29.3385C34.4685 28.7676 33.0992 28.3047 31.41 28.3047C29.7209 28.3047 28.3516 28.7676 28.3516 29.3385C28.3516 29.9095 29.7209 30.3724 31.41 30.3724Z",
    stroke: "#231F20",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectedAmount);
export default __webpack_public_path__ + "static/media/collectedAmount.56ed6ba8b6a5b02514007f391a1d7253.svg";
export { ForwardRef as ReactComponent };